import axios from "axios";
import qs from "qs";

export const setupDAL = () => {
    axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;

    axios.defaults.paramsSerializer = (params) => {
        return qs.stringify(params, {
            arrayFormat: "repeat",
            skipNulls: true,
        });
    };

    axios.interceptors.request.use(
        (req) => {
            req.headers = {
                Authorization: `clientKey ${process.env.REACT_APP_API_CLIENT_KEY}| clientSecret ${process.env.REACT_APP_API_CLIENT_SECRET}`,
            };

            return req;
        },
        function (error) {
            return Promise.reject(error);
        },
    );
};
